<template>
  <div class="lb">
    <div
      ref="barMian"
      class="barMian"
      @mouseover="autoTimePaused = true"
      @mouseout="autoTimePaused = false"
    ></div>
  </div>
</template>

<script>
import * as methods from "./method.js";
export default {
  name: "template.scope99",
  props: {
    vdata: {
      type: [Array, String],
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: "scope95-【组件】双柱图竖轴",
      timer: null,
      defaultdata: [
        {
          value1: "一级",
          value2: "200",
          // value4: "元",
        },
        {
          value1: "二级",
          value2: "500",
        },
        {
          value1: "三级",
          value2: "800",
        },
        {
          value1: "四级",
          value2: "1100",
        },
        {
          value1: "暂无等级",
          value2: "1423",
        },
      ],
      valueMap: [
        { name: "地区名称", key: "value1" },
        { name: "漏斗图数据一", key: "value2" },
        // { name: "单位", key: "value4" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      autoTimePaused: false,
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        this.defaultdata = n;
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
    defaultdata(n) {
      this.DrawEcharts();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    ...methods,
    DrawEcharts() {
      clearInterval(this.timer);
      this.timer = null;
      var echarts = require("echarts");
      const _this = this;
      var TmyChart = echarts.init(this.$refs.barMian);
      let data1 = [];
      let vdata = JSON.parse(JSON.stringify(this.defaultdata));
      let xData = [...new Set(vdata.map((item) => item.value1))];
      vdata.map((item) => {
        if (item.value1 && (item.value2 || item.value2 == 0)) {
          data1.push({
            value: item.value2,
            name: item.value1,
          });
        }
      });
      var Toption = {
        tooltip: {
          trigger: "item",
        },
        color: [
          "#00bff3",
          "#00b0ef",
          "#00a1f6",
          "#0088f9",
          "#0071fb",
          "#0069fb",
          "#005efc",
        ],
        series: [
          {
            // name: "Funnel",
            type: "funnel",
            left: "4%",
            top: "0%",
            width: "60%",
            height: "100%",
            gap: 2,
            label: {
              show: true,
              position: "inside",
              formatter: function (params) {
                return _this.numformat(params.value);
              },
            },
            labelLine: {
              length: 10,
              lineStyle: {
                width: 1,
                type: "dashed",
                color: "#fff",
              },
            },
            itemStyle: {
              borderColor: "transparent",
              borderWidth: 1,
            },
            data: data1,
          },
          {
            // name: "Pyramid",
            type: "funnel",
            left: "0%",
            top: "0%",
            width: "60%",
            height: "100%",
            gap: 2,
            // sort: "ascending",
            funnelAlign: "right",
            itemStyle: {
              opacity: 0,
            },
            label: {
              show: true,
              opacity: 1,
              width: 160,
              overflow: "truncate", //文字超出宽度截断，默认为...
              // position: "inside",
              color: "#fff",
            },
            labelLine: {
              show: false,
              // length: 50,
              // lineStyle: {
              //   opacity: 0.7,
              //   color: "#E1F2FB",
              //   width: 1,
              //   type: "solid",
              // },
            },
            data: data1,
          },
        ],
      };
      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(function () {
        if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000);
    },
  },
  created() {},
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata;
    }
    this.DrawEcharts();
    this.setData(); //需要刷新的数据
  },
};
</script>

<style scoped>
.lb {
  width: 435px;
  height: 240px;
  display: flex;
  overflow: hidden;
  position: relative;
  padding: 10px 0;
}

.barMian {
  width: 100%;
  height: 100%;
}
</style>
